module.exports = __webpack_public_path__ + "ath_game_web/img/5.1.71458106.png";